const REGEXP_PARSE_URL = /(.*)(\?(.*))/;

export function stripLeadingSlash(url) {
    if (url == null) {
        return url;
    }
    return url.indexOf('/') === 0 ? url.substring(1) : url;
}

export function splitQs(qs) {
    const qsObj = {};
    qs.split('&').forEach(function(pair) {
        const splitPair = pair.split('=');
        qsObj[splitPair[0]] = splitPair[1];
    });
    return qsObj;
}

export function appendExistingQueryString(url) {
    const $location = angular.element(document).injector().get('$location');
    const parsed = parse(url);
    const search = $location.search();
    parsed.qs = Object.assign(parsed.qs, search);
    return format(parsed);
}

export function parse(str) {
    const result = {
        url: str,
        qs: {}
    };

    if (str == null) { return result; }

    const match = str.match(REGEXP_PARSE_URL);
    if (match == null) { return result; }
    result.url = match[1];
    result.qs = splitQs(match[3]);
    return result;
}

function formatQs(qs) {
    const keys = Object.keys(qs);
    if (qs == null || keys.length === 0) {
        return null;
    }
    const params = keys.map(function(k) {
        return `${k}=${qs[k]}`;
    });
    return `?${params.join('&')}`;
}

export function format(parsed) {
    const qs = formatQs(parsed.qs);
    return qs ? parsed.url + qs : parsed.url;
}

export function getOrigin() {
    const $window = angular.element(document).injector().get('$window');

    if (!$window.location.origin) {
        return `${$window.location.protocol}//${$window.location.hostname}${$window.location.port ? `:${$window.location.port}` : ''}`;
    }
    return $window.location.origin;
}

export function parseIdBasedUrls(str) {
    const result = {
        url: str
    };
    if (str == null) { return result; }
    const match = result.url.match(/(\d(?:-\d+){1,3})\/(.*)/i);
    if (match == null) { return result; }
    result.idPart = match[1];
    result.urlText = match[2];
    return result;
}

export function parseFullUrl(url) {
    const aElem = document.createElement('a');
    aElem.href = url;
    const { host, port, protocol, pathname } = aElem;
    const pathnameWithoutCulture = pathname.replace(/^\/?[^/]{2}_[^/]{2}\//, '');
    return {
        host,
        port,
        protocol,
        pathname,
        pathnameWithoutCulture
    };
}

